import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { storableError } from '../../util/errors';
import { pageFromSearch, BLOG_PAGE_SIZE } from '../../util/blog';
import { fetchBlogPosts } from '../../util/blogApi';

export const fetchBlogPostsThunk = createAsyncThunk(
  'BlogPage/fetchBlogPosts',
  ({ page }, { rejectWithValue }) => {
    return fetchBlogPosts(page, BLOG_PAGE_SIZE).catch(e => rejectWithValue(storableError(e)));
  }
);

const initialState = {
  posts: [],
  pagination: null,
  fetchInProgress: false,
  fetchError: null,
};

const blogPageSlice = createSlice({
  name: 'BlogPage',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchBlogPostsThunk.pending, state => {
        state.fetchInProgress = true;
        state.fetchError = null;
      })
      .addCase(fetchBlogPostsThunk.fulfilled, (state, action) => {
        state.fetchInProgress = false;
        state.posts = action.payload?.posts || [];
        state.pagination = action.payload?.pagination || null;
      })
      .addCase(fetchBlogPostsThunk.rejected, (state, action) => {
        state.fetchInProgress = false;
        state.fetchError = action.payload;
        state.posts = [];
        state.pagination = null;
      });
  },
});

export default blogPageSlice.reducer;

export const loadData = (params, search) => dispatch => {
  const page = pageFromSearch(search);
  return dispatch(fetchBlogPostsThunk({ page }));
};
